import { useState } from "react";
import { Box } from "@mui/material";
import { FileField, RequestFile, RequestParticipant } from "models/interfaces";
import CheckIcon from "@mui/icons-material/Check";
import { isTruthy } from "helpers/methods";
import { fieldColorFor } from "screens/SignRequest/SignRequestHelper";
import { emitFieldCommit } from "../ParticipantScreenService";

const CustomCheckBoxFieldsElement = ({
  field,
  dispatch,
  selectedFile,
  coords,
  disableFields,
  currentReviewer,
}: {
  field: FileField;
  dispatch: Function;
  selectedFile: RequestFile;
  coords?: any;
  disableFields?: boolean;
  currentReviewer?: RequestParticipant;
}) => {
  const rawValue = field.value as unknown;
  const [isChecked, setIsChecked] = useState<any>(
    rawValue === true || rawValue === "true",
  );
  const isReviewer = isTruthy(currentReviewer?.email);
  const interactive = !!disableFields && !isReviewer && !field.readOnly;

  const toggle = () => {
    if (!interactive) return;
    dispatch({
      type: "UPDATE_FIELD",
      fileId: selectedFile.unsignedPdf,
      fieldId: field.name,
      value: !isChecked,
    });
    setIsChecked(!isChecked);
    emitFieldCommit();
  };

  return (
    <>
      <Box
        role="checkbox"
        aria-checked={!!isChecked}
        aria-label={field.toolTip || "Checkbox"}
        aria-required={field.required}
        aria-disabled={!interactive}
        tabIndex={interactive ? 0 : -1}
        onClick={toggle}
        onKeyDown={(e) => {
          if (interactive && (e.key === " " || e.key === "Enter")) {
            e.preventDefault();
            toggle();
          }
        }}
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: coords.pageHeight,
          height: coords.pageHeight,
          border: `1px solid ${fieldColorFor(field.signerIndex)}`,
          cursor: interactive ? "pointer" : "default",
          "&:focus-visible": {
            outline: `2px solid ${fieldColorFor(field.signerIndex)}`,
            outlineOffset: "2px",
          },
        }}
      >
        {isChecked ? (
          <CheckIcon
            sx={{
              fontSize: coords.pageHeight,
              color: "#ffffff",
              backgroundColor: "red",
            }}
          />
        ) : (
          <></>
        )}
      </Box>
    </>
  );
};

export default CustomCheckBoxFieldsElement;
